import { SUPPLIERS_PERMISSIONS_TO_VIEW } from '@wellbeingxltd/fe-lib/constants'

export const getAccessToAllPages = manager => {
    const updatedManager = { ...manager }
    const ALL_PAGES = Object.keys(SUPPLIERS_PERMISSIONS_TO_VIEW)

    ALL_PAGES.forEach(page => {
        if (!updatedManager.accessToPages[page]) {
            updatedManager.accessToPages[page] = false
        }
    })

    return updatedManager
}
